import { render, staticRenderFns } from "./BannerIcon.vue?vue&type=template&id=2a6ed753&"
import script from "./BannerIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BannerIcon.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BannerIcon.vue?vue&type=style&index=0&id=2a6ed753&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6ed753')) {
      api.createRecord('2a6ed753', component.options)
    } else {
      api.reload('2a6ed753', component.options)
    }
    module.hot.accept("./BannerIcon.vue?vue&type=template&id=2a6ed753&", function () {
      api.rerender('2a6ed753', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/pages/AnalysesListPage/components/DiscountBanner/components/BannerIcon.vue"
export default component.exports